import { Redirect, Router } from "@reach/router";
import IssuersPage from "./pages/issuers";
import ConfigurationPage from "./pages/configuration";
import CardTokenizationPage from "./pages/configuration/card-tokenization";
import "./styles/globals.scss";
import ProfilePage from "./pages/profile";
import { User } from "./utils/helpers/types";
import { RouteGuard } from "./utils/helpers/role-helpers";
import NotFound from "./pages/not-found";
import CertificateUploadPage from "./pages/configuration/certificate-upload";
import ReportsPage from "./pages/reports";
import EcommerceReportsPage from "./pages/ecommerce-report";

const getRoutes: (user: User | null) => JSX.Element = user => {
  const defaultLink = user?.userType === "ISW_ADMIN" ? "/issuers" : "/profile";

  return (
    <Router>
      <Redirect from="/" to={defaultLink} noThrow />
      <Redirect
        from="/spa/isw-tokenization-gateway-portlet"
        to={defaultLink}
        noThrow
      />
      <NotFound default />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISSUER"]}
        component={ProfilePage}
        path="/profile"
      />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={IssuersPage}
        path="/issuers"
      />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={ConfigurationPage}
        path="/configuration"
      />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={CardTokenizationPage}
        path="/configuration/card-tokenization"
      />
      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN"]}
        component={CertificateUploadPage}
        path="/configuration/certificate-upload"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN", "ISSUER"]}
        component={ReportsPage}
        path="/reports"
      />

      <RouteGuard
        currentUser={user}
        allowedUserTypes={["ISW_ADMIN", "ISSUER"]}
        component={EcommerceReportsPage}
        path="/ecommerce-report"
      />
    </Router>
  );
};

export default getRoutes;
